import { useState } from 'react';
import { BugReportModal } from './BugReportModal';

export function BugReportFab() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="fixed bottom-4 right-4 z-50 flex h-9 w-9 items-center justify-center rounded-[10px] bg-[#06141B] shadow-lg shadow-black/30 transition hover:bg-[#0B2535] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#06141B] focus-visible:ring-offset-2"
      >
        <img
          src="/bugreport.svg"
          alt="Reportar problema"
          className="h-5 w-5"
        />
      </button>
      <BugReportModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </>
  );
}

